/**
 * Health Check Page
 * Public endpoint for uptime monitoring
 */

import { Box, Typography, Paper } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { lightColors } from '@rekindle/shared/theme';

export function Health() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: lightColors.background,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          textAlign: 'center',
          maxWidth: 400,
        }}
      >
        <CheckCircleIcon
          sx={{
            fontSize: 64,
            color: 'success.main',
            mb: 2,
          }}
        />
        <Typography variant="h4" gutterBottom>
          ReKindle Admin
        </Typography>
        <Typography variant="h6" color="success.main" gutterBottom>
          Status: Healthy
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Timestamp: {new Date().toISOString()}
        </Typography>
      </Paper>
    </Box>
  );
}
